// extracted by mini-css-extract-plugin
export default {"outlet":"workspaces_outlet__QJsqv","title":"workspaces_title__4oCrg"};